export const RECEIVE_CONFIG = 'RECEIVE_CONFIG';
export const FETCH_CONFIG = 'FETCH_CONFIG';
export const SHOW_CLOSE_BUTTON_IFRAME = 'SHOW_CLOSE_BUTTON_IFRAME';
export const HIDE_CLOSE_BUTTON_IFRAME = 'HIDE_CLOSE_BUTTON_IFRAME';

export function receiveConfig(config) {
  return {
    type: RECEIVE_CONFIG,
    config
  };
}

export function fetchConfig(product) {
  return {
    type: FETCH_CONFIG,
    product
  };
}

export function showCloseIframe() {
  return {
    type: SHOW_CLOSE_BUTTON_IFRAME,
  };
}

export function hideCloseIframe() {
  return {
    type: HIDE_CLOSE_BUTTON_IFRAME,
  };
}
